import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography, Divider } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { useOktaAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';

function UserProfileMenu({ userInfo , onLogout }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

const { oktaAuth } = useOktaAuth() || {};

const handleLogout = async () => {
   handleClose();
    // Revoke tokens
    await oktaAuth.revokeAccessToken();
    await oktaAuth.revokeRefreshToken();

    // Clear all local tokens
    oktaAuth.tokenManager.clear();
  await oktaAuth.signOut({
    postLogoutRedirectUri: window.location.origin +"/logout"
  });
}; // Call the logout function passed as prop
  

  return (
    <div>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        data-testid="profile-icon-button"
      >
        <AccountCircle data-testid="account-icon"/>
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid="profile-menu"
      >
        <MenuItem disabled data-testid="user-name">
         <Typography variant='subtitle'>{userInfo?.name}</Typography>
        </MenuItem>
        <Divider />
          
        <MenuItem onClick={handleLogout} data-testid="logout-button">Logout</MenuItem>
      </Menu>
    </div>
  );
}

UserProfileMenu.propTypes = {
  userInfo: PropTypes.shape({
    name: PropTypes.string,
  }),
  onLogout: PropTypes.func,
};

export default UserProfileMenu;
